<div class="p-grid">
    <div class="p-col-12">
        <app-filter [filterByInput]="cols" [filterByInputValue]="filterByInputValue"
            (onRemoveFilter)="onRemoveFilter(selectedWindow, $event)"
            (onChangeChannel)="onChangeChannel($event)" (onApplyFilter)="onApplyFilter(selectedWindow, $event)"
            (onModifyFilterOptions)="onModifyFilterOptions(selectedWindow, $event)"
            (onChangeRange)="onChangeRange(selectedWindow, $event)">
        </app-filter>
    </div>
    <div class="p-col-12">
        <div class="card">
            <div class="main-content">
                <!-- Finance -->
                <div>
                    <div class="p-d-flex p-jc-between">
                        <div>
                            <h5 class="p-mb-0">{{reportName}}</h5>
                            <div class="p-text-center">
                                {{dateFrom | date:'MM/dd/yyyy'}} - {{dateTo | date:'MM/dd/yyyy'}}
                            </div>
                        </div>
                        <h5>{{organizationName}}</h5>
                        <span class="btnBars" (click)="openSetting()" pTooltip="Show Columns" tooltipPosition="top">
                            <i class="pi pi-cog"></i>
                        </span>
                    </div>

                    <p-table [value]="profitReport" dataKey="financialAccountId" [expandedRowKeys]="expandedRows" 
                    styleClass="p-datatable-gridlines" [resizableColumns]="true">
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width: 2.5rem"></th>
                                <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Name</th>
                                <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Balance Total</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product let-expanded="expanded" let-index="rowIndex">
                            <tr class="child-color">
                                <td class="action">
                                    <button type="button" pButton pRipple [pRowToggler]="product"
                                        class="p-button-text p-button-rounded p-button-plain"
                                        *ngIf="product?.childAccounts?.length > 0"
                                        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                                </td>
                                <td><strong>{{product?.financialAccountName}}</strong></td>
                                <td></td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="rowexpansion" let-product let-index="rowIndex">
                            <ng-container *ngFor="let child of product?.childAccounts; let i = index;">
                                <tr class="cursor-pointer" (click)="openBalanceDetail(child)" *ngIf="selectedWindow=='pLStatement'">
                                    <td style="width: 2.5rem"></td>
                                    <td><span class="p-pl-3">{{child?.financialAccountName}}</span></td>
                                    <td>{{child?.balance | currency:'USD'}}</td>
                                </tr>
                                <tr *ngIf="selectedWindow=='balance'">
                                    <td style="padding-left: 2rem !important;" class="action">
                                        <button type="button" pButton pRipple (click)="child.showChildren = !child.showChildren" 
                                        class="p-button-text p-button-rounded p-button-plain" 
                                        [icon]="child.showChildren ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                                        *ngIf="child.childAccounts.length>0"></button>
                                    </td>
                                    <td><span class="p-pl-3">{{child?.financialAccountName}}</span></td>
                                    <td></td>
                                </tr>
                                <ng-container *ngIf="child.showChildren">
                                    <ng-container *ngFor="let sub of child.childAccounts">
                                      <tr style="background-color: #f6f6f6;">
                                        <td></td>
                                        <td><span class="p-pl-5">{{sub?.financialAccountName}}</span></td>
                                        <td>{{sub?.balance | currency:'USD'}}</td>
                                      </tr>
                                    </ng-container>
                                </ng-container>
                                <tr *ngIf="selectedWindow=='balance'">
                                    <td style="width: 2.5rem"></td>
                                    <td><span class="p-pl-3"><strong>Total {{child?.financialAccountName}}</strong></span></td>
                                    <td><strong>$0.00</strong></td>
                                </tr>
                            </ng-container>
                            <ng-container *ngIf="selectedWindow=='pLStatement'">
                                <tr *ngIf="index == 0">
                                    <td style="width: 2.5rem"></td>
                                    <td><span class="p-pl-3"><strong>Total Income</strong></span></td>
                                    <td><strong>{{totalIncome | currency:'USD'}}</strong></td>
                                </tr>
                                <tr *ngIf="index == 1">
                                    <td style="width: 2.5rem"></td>
                                    <td><span class="p-pl-3"><strong>Total COGS</strong></span></td>
                                    <td><strong>{{totalCOGS | currency:'USD'}}</strong></td>
                                </tr>
                                <tr *ngIf="index == 1">
                                    <td style="width: 2.5rem"></td>
                                    <td><strong>Gross Profit</strong></td>
                                    <td><strong>{{grossProfit | currency:'USD'}}</strong></td>
                                </tr>
                                <tr *ngIf="index == 2">
                                    <td style="width: 2.5rem"></td>
                                    <td><span class="p-pl-3"><strong>Total Expense</strong></span></td>
                                    <td><strong>{{totalExpense | currency:'USD'}}</strong></td>
                                </tr>
                                <tr *ngIf="index == 2">
                                    <td style="width: 2.5rem"></td>
                                    <td><strong>Net Income</strong></td>
                                    <td><strong>{{netIncome | currency:'USD'}}</strong></td>
                                </tr>
                            </ng-container>
                            <ng-container *ngIf="selectedWindow=='balance'">
                                <tr *ngIf="index == 0">
                                    <td style="width: 2.5rem"></td>
                                    <td><strong>Total Assets</strong></td>
                                    <td><strong>$0.00</strong></td>
                                </tr>
                                <tr *ngIf="index == 1">
                                    <td style="width: 2.5rem"></td>
                                    <td><strong>Total Liabilities & Equity</strong></td>
                                    <td><strong>$0.00</strong></td>
                                </tr>
                            </ng-container>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </div>
</div>

<p-dialog header="Transaction Details" [(visible)]="displayBalanceDetail" [modal]="true" [responsive]="true"
    [style]="{width: '60vw'}">
    <div class="header">
        <div style="float: right;margin-top: -4.5px;">
            <p-selectButton [options]="orderOptions" [(ngModel)]="selectedOrder" optionLabel="name" optionValue="value" (onChange)="onChangeOrderOption()"></p-selectButton>
        </div>
        <h5>{{tranTemp?.financialAccountName}}</h5>
    </div>
    <div class="card">
        <!-- <p-table [value]="transactionDetails"> -->
        <p-table [value]="transactionDetails" [lazy]="true" [paginator]="true" [totalRecords]="totalDetailRecord" [(first)]="first" [rows]="pageSize" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            (onPage)="onPageChange($event)" [rowsPerPageOptions]="tableShowMore" paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header">
                <tr>
                    <th>Date</th>
                    <th>Transaction Name</th>
                    <th>Account Name</th>
                    <th>Chart of Account</th>
                    <th>Debit</th>
                    <th>Credit</th>
                    <th>Balance</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-tranDetails let-index="rowIndex">
                <tr>
                    <td>{{tranDetails?.transactionDate | date:'short'}}</td>
                    <td>{{tranDetails?.transactionDetail}}</td>
                    <td>{{tranDetails?.businessName}}</td>
                    <td>{{tranDetails?.chartAccountName}}</td>
                    <td>{{tranDetails?.debit | currency:'USD'}}</td>
                    <td>{{tranDetails?.credit | currency:'USD'}}</td>
                    <td>{{tranDetails?.balance | currency:'USD'}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <ng-template pTemplate="footer">
        <span><strong>Total Balance</strong> {{tranTemp?.balance | currency:'USD'}}</span>
        <br /><br />
        <button pButton (click)="displayBalanceDetail=false;" label="Cancel" class="p-button-secondary"></button>
        <!-- <button pButton label="Save"></button> -->
    </ng-template>
</p-dialog>

<p-dialog header="Columns Settings" [(visible)]="displaySetting" [style]="{width: '550px'}" [modal]="true" [baseZIndex]="10000">
    <div class="card">
        <p-table [value]="columns" selectionMode="single" [(selection)]="selectedColumn" dataKey="id" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
                <tr [pSelectableRow]="product">
                    <td>{{product.name}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <ng-template pTemplate="footer">
        <p-button (click)="displaySetting=false" label="Cancel" styleClass="p-button-secondary"></p-button>
        <p-button (click)="saveSettings()" label="Save"></p-button>
    </ng-template>
</p-dialog>